export const CyberSecurityIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4L38 10V22C38 31.6 32.08 40.56 24 44C15.92 40.56 10 31.6 10 22V10L24 4Z" stroke="#B8860B" strokeWidth="1.5" fill="none"/>
    <path d="M24 8L34 12.5V22C34 29.5 29.5 36.5 24 39.5C18.5 36.5 14 29.5 14 22V12.5L24 8Z" stroke="#B8860B" strokeWidth="1" opacity="0.4" fill="none"/>
    <path d="M20 24L23 27L29 21" stroke="#B8860B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
